export default __webpack_public_path__ + "static/04_嘉宾头像_陈煜琦-45dc4e09551976f186e0f5d39a7bd0ad.png";